<template>
  <div class="evaluateWtapper">
    <div class="evaluateItem" v-for="(item, index) in reply" :key="index">
      <div class="pic-text acea-row row-middle">
        <div class="pictrue">
          <img :src="item.avatar" class="image" />
        </div>
        <div class="acea-row row-middle">
          <div class="name line1">{{ item.nickname }}</div>
          <div
            class="start"
            :class="'star' + (item.serviceScore + item.productScore) / 2"
          ></div>
        </div>
      </div>
      <div class="time">{{ formatDate(item.commentTime) }} {{ item.suk }}</div>
      <div class="evaluate-infor">{{ item.comment }}</div>
      <div class="imgList acea-row">
        <div
          class="pictrue"
          v-for="(itemn, index) in item.pictures"
          :key="index"
        >
          <img :src="itemn" class="image" />
        </div>
      </div>
      <div class="reply" v-if="item.replyContent">
        <span class="font-color-red">店小二</span>：
        {{ item.replyContent }}
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";

export default {
  name: "UserEvaluation",
  props: {
    reply: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {};
  },
  mounted: function () {},
  methods: {
    formatDate(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};
</script>
